module.exports = require('./libs/jquery.min.js');



// WEBPACK FOOTER //
// ./client/assets/jquery.min.js